import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a33ba0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "searchDevice"
}
const _hoisted_2 = {
  key: 1,
  class: "tableHeader"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontalLine" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "ECG ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Data"),
    /*#__PURE__*/_createElementVNode("th", null, "Risultato"),
    /*#__PURE__*/_createElementVNode("th", null, "Modalita"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontalLine" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Pressione arteriosa ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "DIA"),
    /*#__PURE__*/_createElementVNode("th", null, "PR"),
    /*#__PURE__*/_createElementVNode("th", null, "sys"),
    /*#__PURE__*/_createElementVNode("th", null, "utente"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontalLine" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ossigeno ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "DATA"),
    /*#__PURE__*/_createElementVNode("th", null, "Valore"),
    /*#__PURE__*/_createElementVNode("th", null, "PI"),
    /*#__PURE__*/_createElementVNode("th", null, "PR"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontalLine" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "SPO2 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "DIA"),
    /*#__PURE__*/_createElementVNode("th", null, "PR"),
    /*#__PURE__*/_createElementVNode("th", null, "sys"),
    /*#__PURE__*/_createElementVNode("th", null, "utente"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))

import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { onMounted, reactive, ref } from "vue";
import { CheckMeProDevice } from "../model/checkmepro/CheckMeProDevice";
import { CheckMeProBleDevice } from "../services/CheckMeProBleDevice";
import { UseBluetoothReturn, pausableWatch, useBluetooth } from "@vueuse/core";
import { CHECKMEPRO_SERVICE_UUID } from "../BleContstants";
import { ECGItem } from "../model/checkmepro/ECGItem";



export default /*#__PURE__*/_defineComponent({
  __name: 'CheckMeProView',
  setup(__props) {

const isSetup = ref(false);
const isSetupECG = ref(false);
const dataCheck = reactive({} as any);
const ckInstance = CheckMeProBleDevice.getInstance();
const checkMePro = reactive(ckInstance);
const progress = ref(ckInstance.progress);

const {
  isConnected,
  isSupported,
  device,
  requestDevice,
  error,
} = useBluetooth({
  filters: [
    { namePrefix: 'Checkme' },

  ], optionalServices: [CHECKMEPRO_SERVICE_UUID],
  acceptAllDevices: true,
})

onMounted(() => {

});


const { stop } = pausableWatch(isConnected, (newIsConnected) => {
  if (!newIsConnected) {

    return
  }
  checkMePro.device = device.value;


  // Attempt to get the battery levels of the device:
  checkMePro.setupDevice().then(() => {
    checkMePro.infoDevice().then(() => isSetup.value = true)
    .then(() => checkMePro.readUser())
    .then(() => checkMePro.readEcg()
    
      .then(() => checkMePro.readPressure())
     .then(() => checkMePro.readTemperature())
      .then(() => checkMePro.readSpo2())
      )
    .then(() => isSetupECG.value = true)
 
  });

  // We only want to run this on the initial connection, as we will use an event listener to handle updates:
  stop()
})

function showECG(item: ECGItem) {
  checkMePro.readEcgItem(item).then(() =>
    drawCanvas(item)
  )

}
const canvasRef = ref<HTMLCanvasElement | null>(null)


var px = 0;
let canvas;
let ctx;
let speed = 1
let scanBarWidth = 30
let data
let i = 0
let w;
let h;

var opx = 0;
var py;
var opy;

function drawCanvas(item: ECGItem) {


  canvas = canvasRef.value;
  ctx = canvasRef.value.getContext("2d");
  w = 1500
  h = 360
  py = h / 2;
  opy = py;

  const ecgData = localStorage.getItem('ecg')
  data = item.innerItem.ecgData
  if (ecgData == null) {
    data = item.innerItem.ecgData
    localStorage.setItem('ecg', data);
  }
  data = localStorage.getItem('ecg');
  data = item.innerItem.ecgData

  let color = '#00ff00';

  ctx.strokeStyle = color;
  ctx.lineWidth = 3;
  ctx.setTransform(1, 0, 0, -1, 0, h);
  drawWave();
}

function drawWave() {
  console.log("exp")
  if (data == null) {
    data = localStorage.getItem('ecg');
  }

  px += speed;
  ctx.clearRect(px, 0, scanBarWidth, h);
  ctx.beginPath();
  ctx.moveTo(opx, opy);
  ctx.lineJoin = 'round';
  py = (data[++i >= data.length ? i = 0 : i++] / 2);
  //py =+30
  ctx.lineTo(px, py);
  ctx.stroke();
  opx = px;
  opy = py;
  if (opx > w) { px = opx = -speed; }


  requestAnimationFrame(drawWave);
}


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!

  return (_openBlock(), _createBlock(CollapsibleItem, { data: checkMePro }, {
    default: _withCtx(() => [
      (!isSetup.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(requestDevice)())),
              type: "button",
              class: "px-5 py-2.5 mx-10 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
            }, _toDisplayString(_ctx.$t('Ricerca device')), 1)
          ]))
        : _createCommentVNode("", true),
      (isSetup.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", null, "CheckMe Pro " + _toDisplayString(checkMePro.Device.SN) + " " + _toDisplayString(checkMePro.Device.Model), 1),
            _createElementVNode("div", null, "Version " + _toDisplayString(checkMePro.Device.SoftwareVer), 1)
          ]))
        : _createCommentVNode("", true),
      (isSetupECG.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_unref(ckInstance).progress.value) + " ", 1),
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("table", null, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkMePro.ECGs, (value, key) => {
                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.date.toLocaleDateString('it-IT')) + " " + _toDisplayString(value.date.toLocaleTimeString('it-IT')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.imgResultDescr), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.measuringModeDescr), 1)
                    ]),
                    _hoisted_7,
                    _hoisted_8,
                    _createElementVNode("td", null, [
                      _createVNode(_component_font_awesome_layers, {
                        class: "fa-lg icon",
                        onClick: ($event: any) => (showECG(value))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-square",
                            style: { color: '#1A576E' },
                            transform: "grow-6"
                          }),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-eye",
                            transform: "grow-4",
                            style: { width: '100%', color: 'white' },
                            title: "Dettaglio"
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_font_awesome_layers, { class: "fa-lg icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-square",
                            style: { color: '#1A576E' },
                            transform: "grow-6"
                          }),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-download",
                            transform: "grow-4",
                            style: { width: '100%', color: 'white' },
                            title: "Download"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_font_awesome_layers, { class: "fa-lg icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-square",
                            style: { color: '#1A576E' },
                            transform: "grow-6"
                          }),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-save",
                            transform: "grow-4",
                            style: { width: '100%', color: 'white' },
                            title: "Salva sulla tua cartella"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_9,
            _createElementVNode("canvas", {
              ref_key: "canvasRef",
              ref: canvasRef,
              width: "700",
              height: "260",
              style: {"background-color":"black","display":"none"}
            }, null, 512),
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("table", null, [
              _hoisted_12,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkMePro.Pressures, (value, key) => {
                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.date.toLocaleDateString('it-IT')) + " " + _toDisplayString(value.date.toLocaleTimeString('it-IT')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.dia), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.pr), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.sys), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.user.name), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_font_awesome_layers, { class: "fa-lg icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-square",
                            style: { color: '#1A576E' },
                            transform: "grow-6"
                          }),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-download",
                            style: { width: '100%', color: 'white' },
                            title: "Download",
                            transform: "grow-4"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("table", null, [
              _hoisted_15,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkMePro.SPO2Items, (value, key) => {
                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.date.toLocaleDateString('it-IT')) + " " + _toDisplayString(value.date.toLocaleTimeString('it-IT')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.date), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.oxygen), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.pi), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.pr), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_font_awesome_layers, { class: "fa-lg icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-square",
                            style: { color: '#1A576E' },
                            transform: "grow-6"
                          }),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-download",
                            style: { width: '100%', color: 'white' },
                            title: "Download",
                            transform: "grow-4"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("table", null, [
              _hoisted_18,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkMePro.Pressures, (value, key) => {
                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.date.toLocaleDateString('it-IT')) + " " + _toDisplayString(value.date.toLocaleTimeString('it-IT')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.dia), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.pr), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.sys), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h2", null, _toDisplayString(value.user.name), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_font_awesome_layers, { class: "fa-lg icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-square",
                            style: { color: '#1A576E' },
                            transform: "grow-6"
                          }),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-download",
                            style: { width: '100%', color: 'white' },
                            title: "Download",
                            transform: "grow-4"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})